export const returnStringFromArray = (array) => {
    return array
      .map((item) => {
        if (typeof item === "object") {
          let val = Object.values(item)[0];
          if (Array.isArray(val)) {
            return val.join(",");
          }
        }
        return item;
      })
      .join(",");
  };